import { callApi } from '@local_modules/generic/fetch.js'
import { hideElement, setElementHtml, showElement } from '../../../../helpers/generic-js/dom.js'
import htmlTemplateIndex from './user-token.html'
import { showTenantsGrid } from './tenants-grid/show-grid.js'
import { showTokenInfo } from './token-info/show-token-info.js'
/**
 *
 * @returns
 */
export async function showUserToken (params) {
  console.log('showUserToken', params)

  const { containerElementId, browserAppAccount } = params

  // Prepare the html
  const htmlIndex = htmlTemplateIndex

  // Inject in the page
  const containerElement = setElementHtml(containerElementId, htmlIndex)
  if (!containerElement) return

  await runTheShow(browserAppAccount)

  document.addEventListener('cDisassociatedTenant', async () => {
    console.log('cDisassociatedTenant received', browserAppAccount)
    await runTheShow(browserAppAccount)
  })
}

async function runTheShow (browserAppAccount) {
  // 'tenantsGrid'
  const apiTokenResponse = await loadUserToken()

  if (!apiTokenResponse || !apiTokenResponse.tenants || apiTokenResponse.tenants.length === 0) {
    showElement('noConnection')
  } else {
    hideElement('noConnection')
  }

  showTenantsGrid({
    containerElementId: 'tenantsGrid',
    browserAppAccount,
    tokenSetInfo: apiTokenResponse.tokenSetInfo,
    xeroTokenTenants: apiTokenResponse.tenants,
    callbacks: {
      onAssociated: async () => {
        await browserAppAccount.refreshEntities()
        await runTheShow(browserAppAccount)

        document.dispatchEvent(new Event('cAssociatedTenant'))
        console.log('cAssociatedTenant emitted', browserAppAccount)
      }
    }
  })

  showTokenInfo({
    containerElementId: 'tokenInfo',
    apiTokenResponse,
    tokenSetInfo: apiTokenResponse.tokenSetInfo,
    callbacks: {
      onTokenUpdated: async () => {
        await runTheShow(browserAppAccount)
      }
    }
  })
}

async function loadUserToken () {
  const urlEndpoint = '/api/connect-xero/user-token'

  const response = await callApi(urlEndpoint)
  console.log('response', response)

  return response
}
